import type { RemindMeRequest } from "./types"

import { getApiUrl } from "@/modules/api/api"
import { handleResponseNotOk } from "@/modules/apiRequests/handlers"
import { EVENT_DETAILS_PATH, REMIND_ME_ENDPOINT } from "@/modules/eventDetails/client/constants/api"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { DEFAULT_LOCALE } from "@/modules/locales/constants"

export const getRemindMe = async (params: RemindMeRequest): Promise<void> => {
  const { locale, hostname, id } = params

  return fetcher(
    getApiUrl({
      hostname,
      path: `/${locale}${EVENT_DETAILS_PATH}${id}${REMIND_ME_ENDPOINT}`,
      serviceDomain: "MONOLITH_API",
    }),
    {
      headers: {
        "Accept-Language": locale || DEFAULT_LOCALE,
      },
      method: "GET",
    },
    { serviceDomain: "MONOLITH_API", withCCHost: hostname }
  )
    .then(handleResponseNotOk)
    .catch(handleFetchError(REMIND_ME_ENDPOINT, params))
}
